import type { EmitCreateThreadRequest } from './types'
import type { State } from '../state'
import type { WritableDraft } from '../../../../../redux/types'

export function emitCreateThreadRequest(
  state: WritableDraft<State>,
  action: EmitCreateThreadRequest,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
): void {}
